module.exports = __webpack_public_path__ + "static/img/NTH.5cb2247.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NTH.svg
// module id = 3pcx
// module chunks = 1